// extracted by mini-css-extract-plugin
export var addButton = "_q5-0";
export var border = "_q5-8";
export var check = "_q5-h";
export var danger = "_q5-6";
export var dropdownContainer = "_q5-1";
export var editModalBody = "_q5-j";
export var footerContainer = "_q5-i";
export var fullWidth = "_q5-a";
export var hide = "_q5-9";
export var icon = "_q5-3";
export var input = "_q5-7";
export var inputFlex = "_q5-b";
export var inputWrapper = "_q5-c";
export var manualFocus = "_q5-5";
export var optionButton = "_q5-4";
export var pillWrapper = "_q5-e";
export var pointer = "_q5-2";
export var showOverflow = "_q5-f";
export var tagsFlex = "_q5-d";
export var xButton = "_q5-g";